// import jquery from "jquery";
// window.$ = window.jQuery = jquery;

// import * as bootstrap from 'bootstrap';
// window.bootstrap = bootstrap;

import "lazysizes";